<template>
  <v-container fluid>
    <v-row>
      <v-col cols="6" lg="3" v-for="gen in generators" :key="gen.name">
        <GeneratorCard
          @edit="editGenDialog(gen)"
          @select="selectGenerator(gen)"
          :active="gen.name == activeGenerator"
          :name="gen.name"
        ></GeneratorCard>
      </v-col>
      <v-col cols="6" lg="3">
        <v-btn
          size="x-large"
          color="primary"
          @click="
            dialogEdit = false;
            dialogOpen = true;
          "
          >Create Generator</v-btn
        >
      </v-col>
    </v-row>
    <GeneratorDialog
      v-if="dialogOpen"
      :editing="dialogEdit"
      :propGen="dialogGen"
      @cancel="dialogOpen = false"
      @submit="createGenerator"
      @delete="deleteGenerator"
    />
  </v-container>
</template>

<script>
import GeneratorCard from "./GeneratorCard.vue";
import GeneratorDialog from "./GeneratorDialog.vue";

const api = {
  fetch(vm) {
    console.log("Requesting Generators");
    fetch("https://colinbrown.api.stdlib.com/sheets-led@1.0.0/preset/fetch/")
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        const intermediate = data.map((row) => {
          for (const key in row) {
            const parsed = parseFloat(row[key]);
            row[key] = isNaN(parsed) ? row[key] : parsed;
          }
          row.posRange = [row.posValue1, row.posValue2];
          row.velRange = [row.velValue1, row.velValue2];
          row.aRange = [row.aValue1, row.aValue2];
          return [row.name, row];
        });
        vm.generators = Object.fromEntries(intermediate);
        console.log("Generators recieved");
        console.log(vm.generators);
      })
      .catch(function (err) {
        console.log(err);
      });
  },
  insert(nPre) {
    nPre.posValue1 = nPre.posRange[0];
    nPre.posValue2 = nPre.posRange[1];
    nPre.velValue1 = nPre.velRange[0];
    nPre.velValue2 = nPre.velRange[1];
    nPre.aValue1 = nPre.aRange[0];
    nPre.aValue2 = nPre.aRange[1];
    fetch("https://colinbrown.api.stdlib.com/sheets-led@1.0.0/preset/insert/", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(nPre),
    });
  },
  update(nPre) {
    nPre.posValue1 = nPre.posRange[0];
    nPre.posValue2 = nPre.posRange[1];
    nPre.velValue1 = nPre.velRange[0];
    nPre.velValue2 = nPre.velRange[1];
    nPre.aValue1 = nPre.aRange[0];
    nPre.aValue2 = nPre.aRange[1];
    fetch("https://colinbrown.api.stdlib.com/sheets-led@1.0.0/preset/update/", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(nPre),
    });
  },
  delete(name) {
    fetch("https://colinbrown.api.stdlib.com/sheets-led@1.0.0/preset/delete/", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: `{"name" : ` + `"` + name + `"}`,
    });
  },
};

export default {
  props: {
    BLE: Object,
  },
  components: {
    GeneratorCard,
    GeneratorDialog,
  },
  created() {
    api.fetch(this);
  },
  methods: {
    selectGenerator(gen) {
      this.activeGenerator = gen.name;
      this.sendGenerator(gen);
      // this.$emit("select", gen);
    },
    sliderToSpeed(value) {
      return Math.pow(value / 15, 3);
    },
    sliderToDensity(value) {
      return Math.pow(value / 3, 3);
    },
    sendGenerator(gen) {
      var preparedGenerator = {};
      if (gen.generator == "Gradient") {
        preparedGenerator.generator = 0;
        preparedGenerator.rate = this.sliderToSpeed(gen.rate);
        preparedGenerator.density = this.sliderToDensity(gen.density);
      } else if (gen.generator == "Particle") {
        preparedGenerator.generator = 1;
        preparedGenerator.timerDecay =
          gen.particleCount / gen.particleLife / 100;
        preparedGenerator.particleDecay = 1 / gen.particleLife / 100;
        preparedGenerator.range = gen.particleRange;
        preparedGenerator.curveFactor = gen.curveFactor;
        preparedGenerator.referenceDecay = Math.pow(
          gen.persistence,
          1.0 / 100.0
        );

        switch (gen.intensityMethod) {
          case "Fade Out":
            preparedGenerator.intensityMethod = 0;
            break;
          case "Fade In":
            preparedGenerator.intensityMethod = 1;
            break;
          case "Fade In and Out":
            preparedGenerator.intensityMethod = 2;
            break;
          case "Pulse":
            preparedGenerator.intensityMethod = 3;
            break;
        }
        preparedGenerator.intensityValue = gen.intensityValue;

        switch (gen.colorMethod) {
          case "Age":
            preparedGenerator.colorMethod = 0;
            break;
          case "Intensity":
            preparedGenerator.colorMethod = 1;
            break;
          case "Influence":
            preparedGenerator.colorMethod = 2;
            break;
          case "Random":
            preparedGenerator.colorMethod = 3;
            break;
        }

        switch (gen.posMethod) {
          case "Set":
            preparedGenerator.posMethod = 0;
            break;
          case "Random in Range":
            preparedGenerator.posMethod = 1;
            break;
        }
        preparedGenerator.posValue1 = gen.posRange[0];
        preparedGenerator.posValue2 = gen.posRange[1];

        switch (gen.velMethod) {
          case "Set":
            preparedGenerator.velMethod = 0;
            break;
          case "Random in Range":
            preparedGenerator.velMethod = 1;
            break;
        }
        preparedGenerator.velValue1 = gen.velRange[0];
        preparedGenerator.velValue2 = gen.velRange[1];

        switch (gen.calculatedAttribute) {
          case "Position":
            preparedGenerator.calculatedAttribute = 0;
            break;
          case "Velocity":
            preparedGenerator.calculatedAttribute = 1;
            break;
          case "Acceleration":
            preparedGenerator.calculatedAttribute = 2;
            break;
        }
        switch (gen.attributeMethod) {
          case "Constant":
            preparedGenerator.attributeMethod = 0;
            break;
          case "Scaled over Life":
            preparedGenerator.attributeMethod = 1;
            break;
          case "Attractor":
            preparedGenerator.attributeMethod = 2;
        }

        preparedGenerator.aValue1 = gen.aRange[0];
        preparedGenerator.aValue2 = gen.aRange[1];
        preparedGenerator.aValue3 = gen.aValue3;
      }
      console.log(JSON.stringify(preparedGenerator));
      this.BLE.sendGenerator(JSON.stringify(preparedGenerator));
      // this.sendMessage("prst: " + JSON.stringify(preparedGenerator));
    },
    editGenDialog(gen) {
      this.dialogGen = gen;
      this.dialogEdit = true;
      this.dialogOpen = true;
    },
    createGenerator(genString) {
      const gen = JSON.parse(genString);
      this.generators[gen.name] = gen;
      this.dialogOpen = false;

      if (this.dialogEdit) {
        api.update(gen);
      } else {
        api.insert(gen);
      }
    },
    deleteGenerator(genName) {
      if (confirm("Delete Generator?")) {
        api.delete(genName);
        delete this.generators[genName];
        this.dialogOpen = false;
      }
    },
  },
  data: () => ({
    activeGenerator: "",
    generators: [{ name: "Loading..." }],
    dialogOpen: false,
    dialogEdit: false,
    dialogGen: {},
  }),
};
</script> 
